import React from "react";
import { Image as ImageIcon } from "lucide-react";
import { StarBadge } from "@/components/MediaToggle";
import ListToggleButtons from "@/components/ListToggleButtons";
import { TvAvailableDot } from "@/components/TvAvailableBadge";

export default function MovieCard({ item, onOpen }) {
  return (
    <button
      onClick={() => onOpen(item)}
      data-testid={`movie-card-${item.id}`}
      className="poster-card relative rounded-xl overflow-hidden group cursor-pointer text-left bg-[var(--tt-surface)] border border-transparent hover:border-[var(--tt-primary)]/40 transition-colors animate-fade-up"
    >
      <div className="relative aspect-[2/3] w-full overflow-hidden bg-[#0c0c0c]">
        {item.poster ? (
          <img
            src={item.poster}
            alt={item.title}
            loading="lazy"
            className="poster-img w-full h-full object-cover"
          />
        ) : (
          <div className="w-full h-full flex items-center justify-center text-[var(--tt-text-faint)]">
            <ImageIcon className="w-10 h-10" />
          </div>
        )}
        {item.year && (
          <div
            data-testid="movie-card-badge-year"
            className="absolute top-3 left-3 bg-[var(--tt-primary)] text-white text-[11px] font-bold px-2.5 py-1 rounded shadow-md z-10"
          >
            {item.year}
          </div>
        )}
        <StarBadge rating={item.rating} />
        <TvAvailableDot
          tmdbId={item.id}
          mediaType={item.media_type}
          className="absolute top-3 right-3 z-10"
        />
        <div className="absolute bottom-3 right-3 z-20 opacity-0 group-hover:opacity-100 transition-opacity">
          <ListToggleButtons item={item} mediaType={item.media_type} size={14} />
        </div>
        <div className="absolute inset-x-0 bottom-0 h-24 bg-gradient-to-t from-black/90 to-transparent opacity-0 group-hover:opacity-100 transition-opacity" />
      </div>
      <div className="px-2 py-3">
        <div className="text-sm font-semibold truncate group-hover:text-[var(--tt-primary)] transition-colors">
          {item.title}
        </div>
      </div>
    </button>
  );
}
